import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ouraHomeCard from "../assets/images/ourahomecard.PNG";
import ouraIsOut from "../assets/images/ouraisout.PNG";
import ouraReviews from "../assets/images/ourareviews.png";
import ouraAgentic from "../assets/images/ouraagentic.png";
import cortexImg from "../assets/images/cortex.png";
import AOS from "aos";
import "aos/dist/aos.css";
import "./OuraHome.css";
import "./OuraNav.css";
import fetchBase from "../utils/fetchBase";



/* ================= SHARED ICONS ================= */

const ArrowRightIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
    <path d="M9.3 3.7l-1 1 3.1 3.1H1v1.4h10.4l-3.1 3.1 1 1 4.9-5z" />
  </svg>
);

const ExternalLinkIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
    <path d="M13 2.5L12 3.5l1.8 1.8H9c-1.7 0-3 1.3-3 3v2.5h1.2v-2.5c0-1 .8-1.8 1.8-1.8h4.8l-1.8 1.8 1 1 3.5-3.5L13 2.5z" />
  </svg>
);

/* ================= BASIC SECTIONS ================= */

const Header = () => {
  return (
    <header className="bg-white text-[#525252] flex items-center h-[48px] px-6 border-b border-gray-200 overflow-visible">

      {/* LEFT: LOGO */}
      <div className="flex items-center gap-4">
        <span className="text-lg font-semibold text-black">Oura</span>
        <span className="w-px h-6 bg-gray-300"></span>
      </div>

      {/* RIGHT: NAV */}
      <nav className="flex items-center ml-6">

        {["Cloud", "Research", "AI"].map((item, i) => (
          <a
            key={i}
            role="button"
            tabIndex="0"
            href="#"
            aria-haspopup="menu"
            aria-expanded="false"
            className="text-[#525252] px-4 h-[48px] flex items-center gap-1 hover:bg-gray-100 transition-colors"
          >
            {item}

            {/* Arrow Icon */}
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="currentColor"
              className="ml-0.5 opacity-60"
            >
              <path d="M8 11L3 6 3.7 5.3 8 9.6 12.3 5.3 13 6z"></path>
            </svg>
          </a>
        ))}
    <div className="software-menu relative flex items-center px-4 h-[48px]">

      <div className="flex items-center gap-1 text-[#525252] px-4 h-[48px] hover:bg-gray-100 transition-colors cursor-pointer">
        <span>Software</span>
        <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
          <path d="M8 11L3 6 3.7 5.3 8 9.6 12.3 5.3 13 6z" />
        </svg>
      </div>

      <div className="software-dropdown">
        <div className="dropdown-left">
          <Link to="/blog/aaemployee" className="dropdown-item active">
            AA Employee
          </Link>
        </div>

        <div className="dropdown-right">
          <h3>AA Employee →</h3>
          <p>Track employee location, time, and payroll automatically.</p>
        </div>
        </div>
      </div>

      </nav>
    </header>
  );
};
const Hero = () => {
    const handleDemoLogin = async () => {
      try {
        const res = await fetch(`${fetchBase}/api/admin/demo/login`, {
          method: "POST",
        });

        if (!res.ok) {
          alert("Demo login failed");
          return;
        }

        const data = await res.json();

        localStorage.setItem("jwt_token", data.token);

        localStorage.setItem("isDemo", "true");

        window.location.href = "/admin-dashboard";

      } catch (err) {
        console.error(err);
        alert("Error logging into demo");
      }
    };
  return (
    <section
      className="bg-[#f4f4f4]"
      style={{
        backgroundImage: "url('/images/hero-dashboard.png')",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "right center",
        backgroundSize: "60%"
      }}
    >
      <div className="min-h-[75vh] flex items-center max-w-7xl mx-auto px-6">
        <div className="max-w-xl">

          {/* Headline */}
          <h1 className="text-[#0f62fe] text-5xl md:text-6xl font-light tracking-tight mb-6">
            AA Employee
          </h1>

          {/* Subtitle */}
          <p className="text-[#161616] mb-8">
             Know exactly where work happens. AAEmployee tracks when and where employees clock in and automatically logs hours for payroll—so you’re not relying on guesswork.
          </p>

          {/* Buttons */}
          <div className="flex gap-4">
            <button className="bg-[#0f62fe] text-white px-6 py-3">
              Get Started Free
            </button>
            <button
              onClick={handleDemoLogin}
              className="border border-[#0f62fe] text-[#0f62fe] px-6 py-3"
            >
              View Demo
            </button>
          </div>

        </div>
      </div>
    </section>
  );
};
const HolloTech = () => {
  const [email, setEmail] = useState("");

  return (
    <section className="bg-white py-12 border-t">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-4xl md:text-5xl font-light tracking-tight mb-8 text-gray-900">Cortex</h2>

        <div className="grid lg:grid-cols-2 gap-8">
          {/* Form */}
          <div>
          <h3 className="text-lg font-semibold mb-4 text-gray-900">
              Cortex — a universal gaze interaction layer.
            </h3>

            <p className="text-gray-600 text-sm mb-6 max-w-md">
            The mouse defined one era of computing. Touch defined the next. Cortex is our thesis on what comes after — an adaptive engine that converts human attention into computer input, built to ship inside the devices of the next decade.
          </p>

          <form onSubmit={(e) => e.preventDefault()} className="space-y-6">

            <div>
              <label className="block text-xs text-gray-500 mb-2">
                Business email
              </label>

              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full bg-gray-100 border-b-2 border-gray-400 px-4 py-3 text-sm focus:outline-none focus:border-blue-600 transition-colors"
              />
            </div>

            <p className="text-xs text-gray-500 max-w-md">
              You’ll receive occasional updates about new features and improvements. You can unsubscribe at any time.
            </p>

            <button className="bg-[#0f62fe] text-white px-8 py-3 hover:bg-[#0043ce] transition">
                Join the Research Cohort
            </button>
          </form>
        </div>

          {/* Illustration */}
            <img
                src={cortexImg}
                alt="HolloTech"
                className="w-full h-48 object-cover object-[50%_40%]"
              />
        </div>
      </div>
    </section>
  );
};
const LatestNews = () => {
  const newsItems = [
    "Oura Fellow and Quantum Pioneer Charles H. Bennett Receives A.M. Turing Award",
    "Oura and Lam Research Announce Collaboration",
    "SEI Engages Oura to Accelerate Enterprise Transformation",
    "Oura Creates a Never-Before-Seen Molecule",
  ];

  return (
    <section className="bg-white py-10 border-t">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-sm font-semibold mb-6 text-gray-900">
          Latest News
        </h2>

        {newsItems.map((item, index) => (
          <div
            key={index}
            className="py-4 border-b flex justify-between items-center hover:bg-gray-100 px-2"
          >
            <span className="text-blue-600">{item}</span>
            <span className="text-blue-600">
              <ArrowRightIcon />
            </span>
          </div>
        ))}
      </div>
    </section>
  );
};
const RecommendedCards = () => {
  const cards = [
      {
        title: "Manage Your Entire Workflow With One Unified Platform.",
        category: "Product",
        link: "/demo",
      },
      {
        title: "AI at scale with Red Hat",
        category: "News",
      },
      {
        title: "Agentic Systems",
        category: "Guide",
      },
      {
          title: "Real Results, Real Reviews",
          category: "Case study",
      },
    ];

  return (
    <section className="bg-white py-10">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-sm font-semibold mb-6 text-gray-900">
          Recommended for you
        </h2>

        <div className="grid md:grid-cols-2 gap-4">
          {cards.map((card, index) => {
            const CardWrapper = card.link ? Link : "div";
            const wrapperProps = card.link ? { to: card.link } : {};
            return (
            <CardWrapper
              key={index}
              {...wrapperProps}
              className="bg-white border p-6 hover:bg-gray-50 hover:shadow-md transition-all duration-200 flex items-center gap-6 min-h-[180px]"
            >
              {/* LEFT IMAGE */}
              {card.link === "/demo" ? (
                <img
                  src={ouraHomeCard}
                  alt={card.title}
                  className="w-28 h-28 object-cover flex-shrink-0"
                />
              ) : card.category === "News" ? (
                <img
                  src={ouraIsOut}
                  alt={card.title}
                  className="w-28 h-28 object-cover flex-shrink-0"
                />
              ) : card.category === "Case study" ? (
                  <img
                    src={ouraReviews}
                    alt={card.title}
                    className="w-28 h-28 object-cover flex-shrink-0"
                  />
                ) : card.category === "Guide" ? (
                  <img
                    src={ouraAgentic}
                    alt={card.title}
                    className="w-28 h-28 object-cover flex-shrink-0"
                  />
                ) : (
                  <div className="w-28 h-28 bg-gray-200 flex-shrink-0"></div>
                )}

              {/* RIGHT CONTENT */}
              <div className="flex flex-col justify-between flex-1 h-full">

                <div>
                  <span className="text-xs uppercase tracking-wide text-gray-500">
                    {card.category}
                  </span>

                  <h3 className="mt-3 text-gray-900 font-medium">
                    {card.title}
                  </h3>
                </div>

                <div className="mt-6 text-blue-600">
                  <ArrowRightIcon />
                </div>

              </div>
              </CardWrapper>
            );})}
          </div>
        </div>
      </section>
    );
    };
    const PromoBanner = () => {
  return (
    <section className="bg-white py-10">
      <div className="max-w-7xl mx-auto px-6">
        <div className="bg-[#0f62fe] text-white p-6 flex justify-between items-center hover:bg-[#0043ce] transition">

          <div>
            <h3 className="text-lg font-semibold mb-1">
              Save 30% on select Oura products
            </h3>
            <p className="text-sm opacity-90">
              Shop deals on smart solutions that are easy to deploy—until November 2026.
            </p>
          </div>

          <div>
            <ArrowRightIcon />
          </div>

        </div>
      </div>
    </section>
  );
};
const EnterpriseTechnology = () => {
  const items = [
    {
      title: "Vertical AI",
      desc: "Domain-specific AI built for regulated industries",
    },
    {
      title: "Agentic Systems",
      desc: "Exploring AI agents that act on workflows directly",
    },
    {
      title: "Proprietary ML Infrastructure",
      desc: "Model training and fine-tuning pipelines",
    },
    {
      title: "Distributed Systems Architecture",
      desc: "Scale across regions without sacrificing reliability",
    },
  ];

  return (
    <section className="bg-white py-12 border-t">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-4xl md:text-5xl font-light tracking-tight mb-8 text-gray-900">
          Engineering What's Ahead
        </h2>

        <div className="grid md:grid-cols-2 gap-4">
          {items.map((item, i) => (
            <div
              key={i}
              className="cds-tile-trace bg-white p-6 min-h-[140px] flex flex-col justify-between"
            >
              <div>
                <h3 className="font-semibold text-gray-900 mb-2">
                  {item.title}
                </h3>
                <p className="text-[15px] font-normal text-gray-600 leading-relaxed">
                  {item.desc}
                </p>
              </div>

              <div className="text-blue-600 mt-4">
                <ArrowRightIcon />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
const InsideOura = () => {
  const sections = [
    {
      title: "For Founders & Directors",
      desc: "What founders need to know before choosing software that runs their business.",
    },
    {
      title: "For Operations & Managers",
      desc: "The technical detail behind compliance, workflows, and the systems that keep operations running.",
    },
    {
      title: "For Consumers",
      desc: "See our products in action — real use cases from real customers.",
    },
  ];

  return (
    <section className="bg-white py-12 border-t">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-4xl md:text-5xl font-light tracking-tight mb-8 text-gray-900">
          Inside Oura
        </h2>

        <div className="grid md:grid-cols-3 gap-6">
          {sections.map((s, i) => (
            <div key={i}>
              <h3 className="font-semibold mb-2 text-gray-900">
                {s.title}
              </h3>
              <p className="text-sm text-gray-600 mb-3">
                {s.desc}
              </p>

              <div className="text-blue-600 flex items-center gap-2">
                Learn more <ArrowRightIcon />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

/* ================= STAY CONNECTED ================= */

const StayConnected = () => {
  const [email, setEmail] = useState("");

  return (
    <section className="bg-white py-12 border-t">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-4xl md:text-5xl font-light tracking-tight mb-8 text-gray-900">Stay connected</h2>

        <div className="grid lg:grid-cols-2 gap-8">
          {/* Illustration */}
          <div className="bg-blue-600 h-48"></div>

          {/* Form */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-gray-900">
              Stay updated on the latest
            </h3>

            <p className="text-gray-600 text-sm mb-6 max-w-md">
              Get product updates, feature releases, and insights on managing your workforce more efficiently with Oura.
            </p>

            <form onSubmit={(e) => e.preventDefault()} className="space-y-6">

              <div>
                <label className="block text-xs text-gray-500 mb-2">
                  Business email
                </label>

                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full bg-gray-100 border-b-2 border-gray-400 px-4 py-3 text-sm focus:outline-none focus:border-blue-600 transition-colors"
                />
              </div>

              <p className="text-xs text-gray-500 max-w-md">
                You’ll receive occasional updates about new features and improvements. You can unsubscribe at any time.
              </p>

              <button className="bg-[#0f62fe] text-white px-8 py-3 hover:bg-[#0043ce] transition">
                Subscribe
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

/* ================= MAIN ================= */

const OuraHome = () => {
  useEffect(() => {
    AOS.init();
  }, []);

  return (
    <>
      <Header />
        <Hero />
        <HolloTech />
        {/* <LatestNews /> */}
        <RecommendedCards />
      <PromoBanner />
      <EnterpriseTechnology />
      <InsideOura />
      <StayConnected />
    </>
  );
};

export default OuraHome;